export const fileExtensions = [
  '.c',
  '.cpp',
  '.cs',
  '.css',
  '.doc',
  '.docx',
  '.go',
  '.html',
  '.java',
  '.js',
  '.json',
  '.md',
  '.pdf',
  '.php',
  '.pptx',
  '.py',
  '.rb',
  '.sh',
  '.tex',
  '.ts',
  '.txt',
  '.msg', // Converted to txt
  '.xls', // Converted to txt
  '.xlsx', // Converted to txt
  '.url', // Converted to txt
  '.csv', // Converted to txt
];

export const section_template_types = [
  { label: 'Manual Entry', value: 'manual' },
  { label: 'AI Summarized', value: 'ai' },
];
